import React, { useState, useEffect, useRef } from "react";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import {
  embedColorCode,
  freeUsersSizeLimitListJumboForms,
  subscribersSizeLimitListJumboForms,
  businessSizeLimitListJumboForms,
  premiumSizeLimitListJumboForms,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";

const FilesFormats = ({
  manuallyDeleteCheckbox,
  setManuallyDeleteCheckbox,
  automaticallyDeleteCheckbox,
  setAutomaticallyDeleteCheckbox,
  uploadAnyFormatsCheckbox,
  setUploadAnyFormatsCheckbox,
  allowFolowingFormatsCheckbox,
  setAllowFolowingFormatsCheckbox,
  denyForamtsCheckbox,
  setDenyForamtsCheckbox,
  daysToDelete,
  setDaysToDelete,
  setFileSizeLimit,
  fileSizeLimit,
  setUploadFilesLimit,
  uploadFilesLimit,
  setFileFormats,
  fileFormats,
  invalidFilesFormat,
  setInvalidFilesFormat,
  setInvalidAlert,
  setUpdateBeforeSave,
  invalidAlert,
}) => {
  const { setModal } = useModal();
  const { getTextByKey, getDirection, getHtmlByKey } = useContent();
  const { isSubscribed, isPremium, isBusiness } = useUser();
  const [backgroundSlider, setBackgroundSlider] = useState(null);
  const [styleLabeLLimits, setStyleLabeLLimits] = useState({});
  const maxUploadSize = premiumSizeLimitListJumboForms;
  //Max number of files
  const checkFilesLimitValidation = (num) => {
    const re = /^[0-9\b]+$/;
    if (num === "" || re.test(num)) {
      if (num < 0) {
        setUploadFilesLimit(0);
      } else {
        setUploadFilesLimit(num);
      }
    }
  };
  const [tempFocusNumbOfFiles, setTempFocusNumbOfFiles] = useState(null);
  const [tempBlurNumOfFiles, setTempBlurNumOfFiles] = useState(null);
  useEffect(() => {
    if (tempBlurNumOfFiles !== tempFocusNumbOfFiles) {
      setUpdateBeforeSave({ mode: true, action: "updateUploadFilesLimit" });
    }
  }, [tempBlurNumOfFiles]);

  //Max size to upload
  const maxSizes = [9, 10, 1, 11, 2, 3, 4, 5, 6, 7, 12, 13, 16, 17, 18, 19, 20];
  const listDisplaySizes = [
    { num: 9, size: "10MB", display: true },
    { num: 10, size: "25MB", display: true },
    { num: 1, size: "50MB", display: true },
    { num: 11, size: "100MB", display: true },
    { num: 2, size: "200MB", display: true },
    { num: 3, size: "500MB", display: true },
    { num: 4, size: "750MB", display: true },
    { num: 5, size: "1GB", display: true },
    { num: 6, size: "1.5GB", display: true },
    { num: 7, size: "2GB", display: true },
    { num: 12, size: "4GB", display: true },
    { num: 13, size: "5GB", display: true },
    { num: 16, size: "8GB", display: true },
    { num: 17, size: "10GB", display: true },
    { num: 18, size: "20GB", display: true },
    { num: 19, size: "50GB", display: true },
    { num: 20, size: "500GB", display: true },
  ];

  const [sliderValue, setSliderValue] = useState(
    maxSizes.indexOf(fileSizeLimit)
  );

  const [widthFilled, setWidthFilled] = useState(0);

  const handleScaleMobile = (e) => {
    setFileSizeLimit(e.target.value);
  };

  //set the value of the progressbar background filled
  useEffect(() => {
    if (maxSizes[sliderValue] !== fileSizeLimit) {
      setUpdateBeforeSave({ mode: true, action: "updateFileSizeLimit" });
    }
    let styleLabel = 1;
    setFileSizeLimit(maxSizes[sliderValue]);
    if (parseInt(sliderValue) === 0) {
      setWidthFilled(0);
      styleLabel = 0;
    } else if (parseInt(sliderValue) === premiumSizeLimitListJumboForms) {
      setWidthFilled(100);
      styleLabel = 1;
    } else if (parseInt(sliderValue) > 2 && parseInt(sliderValue) <= 6) {
      let num = (parseInt(sliderValue) / 17) * 100;
      setWidthFilled(num + 2);
      styleLabel = (num - 1) / 100;
    } else if (parseInt(sliderValue) > 6) {
      let num = (parseInt(sliderValue) / 17) * 100;
      setWidthFilled(num + 4);
      styleLabel = (num + 2) / 100;
    } else {
      let num = (parseInt(sliderValue) / 17) * 100;
      styleLabel = (num + 2) / 100;
      setWidthFilled(num + 2);
    }

    setStyleLabeLLimits(styleLabel);
  }, [sliderValue]);

  useEffect(() => {
    let tempBackground =
      `linear-gradient(to left, ${embedColorCode} ` +
      widthFilled +
      "%, #D6D6D6 " +
      widthFilled +
      "%)";
    if (getDirection() === "rtl") {
      tempBackground =
        `linear-gradient(to left, ${embedColorCode} ` +
        widthFilled +
        "%, #D6D6D6 " +
        widthFilled +
        "%)";
    } else {
      tempBackground =
        `linear-gradient(to right, ${embedColorCode} ` +
        widthFilled +
        "%, #D6D6D6 " +
        widthFilled +
        "%)";
    }
    setBackgroundSlider(tempBackground);
  }, [widthFilled, getDirection]);

  const [tempFocusFilesSize, setTempFocusFilesSize] = useState(null);
  const [tempBlurFilesSize, setTempBlurFilesSize] = useState(null);

  useEffect(() => {
    if (tempBlurFilesSize !== tempFocusFilesSize) {
      setUpdateBeforeSave({ mode: true, action: "updateFileSizeLimit" });
    }
  }, [tempBlurFilesSize]);

  //Days to delete
  const listDays = [1, 2, 3, 4, 5, 6, 7, 10, 14, 30, 45, 60, 180, 365];
  const [tempFocusNumOfDays, setTempFocusNumOfDays] = useState(null);
  const [tempBlurNumOfDays, setTempBlurNumOfDays] = useState(null);
  const [updateDeleteMails, setUpdateDeleteMails] = useState(false);
  useEffect(() => {
    if (tempBlurNumOfDays !== tempFocusNumOfDays) {
      setUpdateDeleteMails(true);
    }
  }, [tempBlurNumOfDays]);

  const toggleAutomaticallyDelete = () => {
    if (isSubscribed()) {
      if (!automaticallyDeleteCheckbox) {
        setAutomaticallyDeleteCheckbox(true);
        setManuallyDeleteCheckbox(false);
        setUpdateDeleteMails(true);
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const toggleManuallyDelete = () => {
    if (isSubscribed()) {
      if (!manuallyDeleteCheckbox) {
        setManuallyDeleteCheckbox(true);
        setAutomaticallyDeleteCheckbox(false);
        setUpdateDeleteMails(true);
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };
  useEffect(() => {
    if (updateDeleteMails) {
      setUpdateBeforeSave({ mode: true, action: "updateDeleteMails" });
      setUpdateDeleteMails(false);
    }
  }, [updateDeleteMails]);

  //File formats
  const ref = useRef();
  const [tempFocusTextareaFormats, setTempFocusTextareaFormats] =
    useState(null);
  const [tempBlurTextareaFormats, setTempBlurTextareaFormats] = useState(null);
  useEffect(() => {
    if (
      tempBlurTextareaFormats !== tempFocusTextareaFormats &&
      !uploadAnyFormatsCheckbox
    ) {
      const valid = checkValidateForamts();
      if (valid) {
        setInvalidFilesFormat(false);
        setInvalidAlert(null);
        setUpdateBeforeSave({ mode: true, action: "updateFileFormats" });
      }
    }
  }, [tempBlurTextareaFormats]);

  const handleChangeTextareaFormats = (e) => {
    setFileFormats(e);
    setInvalidAlert(null);
    setInvalidFilesFormat(false);
  };

  const handleAllowAnyFormats = () => {
    if (isPremium() || isBusiness()) {
      if (!uploadAnyFormatsCheckbox) {
        setFileFormats("");
        setUploadAnyFormatsCheckbox(true);
        setDenyForamtsCheckbox(false);
        setAllowFolowingFormatsCheckbox(false);
        setInvalidFilesFormat(false);
        setInvalidAlert(null);
        setUpdateBeforeSave({ mode: true, action: "updateFileFormats" });
      }
    } else {
      setModal(() => (
        <EmbedLimitOptionsModal typeOfModal={"business-premium"} />
      ));
    }
  };

  const handleAllowFollowingFormats = () => {
    if (isPremium() || isBusiness()) {
      if (!allowFolowingFormatsCheckbox) {
        setAllowFolowingFormatsCheckbox(true);
        setDenyForamtsCheckbox(false);
        setUploadAnyFormatsCheckbox(false);
        const valid = checkValidateForamts();
        if (valid) {
          setInvalidFilesFormat(false);
          setInvalidAlert(null);
          setUpdateBeforeSave({ mode: true, action: "updateFileFormats" });
        }
      }
    } else {
      setModal(() => (
        <EmbedLimitOptionsModal typeOfModal={"business-premium"} />
      ));
    }
  };

  const handleDenyFormats = () => {
    if (isPremium() || isBusiness()) {
      if (!denyForamtsCheckbox) {
        setDenyForamtsCheckbox(true);
        setAllowFolowingFormatsCheckbox(false);
        setUploadAnyFormatsCheckbox(false);
        const valid = checkValidateForamts();
        if (valid) {
          setInvalidFilesFormat(false);
          setInvalidAlert(null);
          setUpdateBeforeSave({ mode: true, action: "updateFileFormats" });
        }
      }
    } else {
      setModal(() => (
        <EmbedLimitOptionsModal typeOfModal={"business-premium"} />
      ));
    }
  };

  //check validation of formats files input
  const checkValidateForamts = () => {
    const validFormats = new RegExp("^[0-9a-z]{2,10}$");
    let formats = "";
    if (fileFormats) {
      formats = fileFormats.trim();
      formats = formats.replace(/\./g, "");
      if (formats.includes(",")) {
        let str = "";
        formats = formats.split(",");
        if (formats.length > 50) {
          setInvalidFilesFormat(true);
          setInvalidAlert(getTextByKey("error-max-file-formats"));
        }
        for (let i = 0; i < formats.length; i++) {
          const element = formats[i];
          if (
            element !== null &&
            element !== undefined &&
            element !== "" &&
            element.length > 0
          ) {
            var isValid = validFormats.test(element);
            if (!isValid) {
              if (i === formats.length - 1) {
                str += element;
              } else {
                str += element + ", ";
              }
            }
          }
        }
        if (str.length > 0) {
          setInvalidFilesFormat(true);
          setInvalidAlert(getTextByKey("invalid-file-format") + " " + str);
          return false;
        }
      } else {
        if (!validFormats.test(fileFormats.trim())) {
          setInvalidFilesFormat(true);
          setInvalidAlert(
            getTextByKey("invalid-file-format") + " " + fileFormats
          );
          return false;
        }
        if (fileFormats === "" || fileFormats === null) {
          setInvalidFilesFormat(true);
          setInvalidAlert(getTextByKey("empty-files-format"));
          return false;
        }
      }
    } else {
      setInvalidFilesFormat(true);
      setInvalidAlert(getTextByKey("empty-files-format"));
      return false;
    }

    return true;
  };

  const openLimitModal = () => {
    if (!isPremium() && !isBusiness()) {
      setModal(() => (
        <EmbedLimitOptionsModal typeOfModal={"business-premium"} />
      ));
    }
  };

  const handleChangeSlider = (e) => {
    const maxUploadSizeLimit = isPremium()
      ? premiumSizeLimitListJumboForms
      : isSubscribed()
      ? isBusiness()
        ? businessSizeLimitListJumboForms
        : subscribersSizeLimitListJumboForms
      : freeUsersSizeLimitListJumboForms;
    if (e <= maxUploadSizeLimit) {
      setSliderValue(e);
    } else {
      setModal(() => <EmbedLimitOptionsModal typeOfModal={"not-available"} />);
    }
  };

  const handleChangeDaysLimit = (e) => {
    if (isSubscribed()) {
      if (isPremium()) {
        setDaysToDelete(e);
      } else {
        if (e <= 7) {
          setDaysToDelete(e);
        } else {
          setModal(() => <EmbedLimitOptionsModal />);
        }
      }
    } else {
      if (e <= 2) {
        setDaysToDelete(e);
      } else {
        setModal(() => <EmbedLimitOptionsModal />);
      }
    }
  };

  return (
    <div className="files-settings option">
      <div className="max-size type-option">
        <div className="title-input">
          <span className="text span-text">{getTextByKey("maximum-size")}</span>
          <Tooltip
            id={"maximum-size"}
            tooltipTextKey="maximum-size-tooltip"
            //hardPositioned
            end
          >
            <Icon name="question-circle" iconClass="tooltip-question" />
          </Tooltip>
        </div>
        <div
          className={`progressbar ${
            getDirection() === "rtl" ? "progressbar-rtl" : ""
          }`}
        >
          {window.innerWidth > 700 ? (
            <>
              <input
                onFocus={(e) => setTempFocusFilesSize(e.target.value)}
                onBlur={(e) => setTempBlurFilesSize(e.target.value)}
                style={{ background: backgroundSlider }}
                className="slider-input"
                type="range"
                value={maxSizes.indexOf(fileSizeLimit)}
                min="0"
                max={maxUploadSize}
                onChange={(e) => handleChangeSlider(e.target.value)}
                id="myRange"
              />
              <div
                className="label-limits"
                style={{
                  left:
                    getDirection() === "ltr"
                      ? maxSizes[sliderValue] === 20
                        ? 92 + "%"
                        : styleLabeLLimits * 100 - 2 + "%"
                      : "unset",
                  right:
                    getDirection() === "rtl"
                      ? maxSizes[sliderValue] === 20
                        ? 92 + "%"
                        : styleLabeLLimits * 100 - 2 + "%"
                      : "unset",
                }}
              >
                <span className="label-limit-span">
                  {listDisplaySizes[maxSizes.indexOf(fileSizeLimit)].size}
                </span>
              </div>
            </>
          ) : (
            <div>
              <select
                value={fileSizeLimit}
                onChange={handleScaleMobile}
                onFocus={(e) => setTempFocusFilesSize(e.target.value)}
                onBlur={(e) => setTempBlurFilesSize(e.target.value)}
              >
                {listDisplaySizes.map((item, i) => (
                  <option key={i} value={item.num}>
                    {item.size}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
      <div className="upload-files type-option">
        <div className="title-input">
          <span className="text span-text">
            {getHtmlByKey("upload-files-limit")}
          </span>
          <Tooltip
            id={"upload-files"}
            tooltipTextKey="upload-files-limit-tooltip"
            //hardPositioned
            end
          >
            <Icon name="question-circle" iconClass="tooltip-question" />
          </Tooltip>
        </div>
        <div className="input-number-files" onClick={openLimitModal}>
          <input
            disabled={isPremium() || isBusiness() ? false : true}
            onBlur={(e) => setTempBlurNumOfFiles(e.target.value)}
            onFocus={(e) => setTempFocusNumbOfFiles(e.target.value)}
            min="0"
            type="number"
            value={uploadFilesLimit}
            onChange={(e) => {
              checkFilesLimitValidation(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="delete-files type-option">
        <div className="title-input">
          <span className="text span-text">{getTextByKey("delete-files")}</span>
        </div>
        <div className="radio-options">
          <div className="input-status-div">
            <Image
              alt=""
              title=""
              className="input-checkbox"
              onClick={() => {
                toggleManuallyDelete();
              }}
              name={
                manuallyDeleteCheckbox ? "radio-checked" : "radio-unchecked"
              }
              ext="svg"
            />
            <span className="input-label span-text">
              {getTextByKey("delete-mails-manually")}
            </span>{" "}
            <Tooltip
              id={"manually"}
              tooltipTextKey="delete-mails-manually-tooltip"
              //hardPositioned
              end
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
          <div className="input-status-div manual-delete">
            <div className="first-div">
              <Image
                alt=""
                title=""
                className="input-checkbox"
                onClick={() => {
                  toggleAutomaticallyDelete();
                }}
                name={
                  automaticallyDeleteCheckbox
                    ? "radio-checked"
                    : "radio-unchecked"
                }
                ext="svg"
              />
              <span className="input-label span-text">
                {getTextByKey("delete-mails-auto")}
              </span>{" "}
            </div>
            <div className="second-div">
              <div className="list-days">
                <select
                  value={daysToDelete}
                  onChange={(e) => {
                    handleChangeDaysLimit(e.target.value);
                  }}
                  onFocus={(e) => setTempFocusNumOfDays(e.target.value)}
                  onBlur={(e) => setTempBlurNumOfDays(e.target.value)}
                  className={`${manuallyDeleteCheckbox ? "disabled" : ""}`}
                >
                  {listDays.map((item, i) => (
                    <option
                      value={item}
                      disabled={manuallyDeleteCheckbox}
                      key={i}
                    >
                      {item}
                    </option>
                  ))}
                </select>
              </div>{" "}
              <span className="span-text">
                {getTextByKey("delete-mails-auto-text")}
              </span>
            </div>
          </div>
          {!isSubscribed() && (
            <div className="free-users-auto-delete">
              <span className="span-text">
                {getTextByKey("delete-auto-free-text")}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="files-formats type-option">
        <div className="title-input">
          <span className="text span-text">
            {getTextByKey("files-format-limitations")}
          </span>
        </div>
        <div className="radio-options">
          <div className="input-status-div">
            <Image
              alt=""
              title=""
              className="input-checkbox"
              onClick={() => {
                handleAllowAnyFormats();
              }}
              name={
                uploadAnyFormatsCheckbox ? "radio-checked" : "radio-unchecked"
              }
              ext="svg"
            />
            <span className="input-label span-text">
              {getTextByKey("allow-any-format")}
            </span>{" "}
          </div>
          <div className="input-status-div">
            <Image
              alt=""
              title=""
              className="input-checkbox"
              onClick={() => {
                handleAllowFollowingFormats();
              }}
              name={
                allowFolowingFormatsCheckbox
                  ? "radio-checked"
                  : "radio-unchecked"
              }
              ext="svg"
            />
            <span className="input-label span-text">
              {getTextByKey("allow-specific-formats")}
            </span>{" "}
          </div>
          <div className="input-status-div">
            <Image
              alt=""
              title=""
              className="input-checkbox"
              onClick={(e) => {
                handleDenyFormats();
              }}
              name={denyForamtsCheckbox ? "radio-checked" : "radio-unchecked"}
              ext="svg"
            />
            <span className="input-label span-text">
              {getTextByKey("deny-specific-formats")}
            </span>{" "}
          </div>
          <div
            className={`show-text-area ${invalidFilesFormat ? "invalid" : ""} ${
              uploadAnyFormatsCheckbox ? "hide" : ""
            }`}
          >
            <textarea
              ref={ref}
              className={`${uploadAnyFormatsCheckbox ? "disabled" : ""}`}
              value={fileFormats}
              onChange={(e) => handleChangeTextareaFormats(e.target.value)}
              onFocus={(e) => setTempFocusTextareaFormats(e.target.value)}
              onBlur={(e) => setTempBlurTextareaFormats(e.target.value)}
              disabled={uploadAnyFormatsCheckbox}
            />
            {invalidAlert && (
              <div className="invalid-alert-text">{invalidAlert}</div>
            )}
            <div className="small-text">
              <span className="span-text">
                {getTextByKey("files-format-text")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilesFormats;
